import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import Loading from "components/Loading";
import Typography from "components/Typography";
import {makeStyles} from "@material-ui/styles";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import EzdrpService from "services/EzdrpService";
import EzdrpList from "./EzdrpList";

const useStyle = makeStyles(theme => ({
    root: {},
    rotate: {
        transform: 'rotate(90deg)'
    },
    breadcrumbText: {
        marginRight: theme.spacing(2)
    },
    checkbox: {
        padding: "0 11px"
    },
    selDocuments: {
        marginRight: 200
    },
    dialogContent: {
        minHeight: 500
    },
    loading: {
        position: 'absolute',
        width: 900,
        height: 50
    },
    titleIcon: {
        position: 'absolute',
        left: theme.spacing(2),
        color: theme.palette.primary.main,
    }
}))


function EzdrpExplorer(
    {
        demandId,
        onClose,
        handleSubmit
    }) {
    const classes = useStyle();
    const [filesAndFolders, setFilesAndFolders] = useState(null);
    const [selectedFileMap, setSelectedFilesMap] = useState(new Map());
    const [expandedFileMap, setExpandedFilesMap] = useState(new Map());
    const [working, setWorking] = useState(true);

    useEffect(() => {
        EzdrpService.getFilesAdnFolders(demandId).then((resp) => setFilesAndFolders(resp)).then(() => setWorking(false)).catch(onClose);
        // eslint-disable-next-line
    }, [demandId])


    const toggleSelectFile = (file) => {
        const newMap = new Map(selectedFileMap);
        if (newMap.has(file.id)) {
            newMap.delete(file.id);
            setSelectedFilesMap(newMap);
        } else {
            const {attachments, ...others} = file;
            newMap.set(file.id, others)
            setSelectedFilesMap(newMap);
        }
    }
    const toggleExpandFile = (file) => {
        const newMap = new Map(expandedFileMap);
        if (newMap.has(file.id)) {
            newMap.delete(file.id);
            setExpandedFilesMap(newMap);
        } else {
            newMap.set(file.id, file.id)
            setExpandedFilesMap(newMap);
        }
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined'));
        buttons.push(createButton(Tr('add'), () => handleSubmit(Array.from(selectedFileMap).map(([key, value]) => value)), undefined, selectedFileMap.size === 0));
        return buttons;
    }

    return (
        <Dialog
            open
            title={
                <div>
                    {Tr("int_explorer_dialog_title_x", {x: "ezdrp"}, true)}
                </div>}
            titleCentered
            maxWidth="md"
            onClose={onClose}
            contentClassName={classes.dialogContent}
            dialogActions={
                <>
                    <MultiButton
                        buttons={getButtons()}
                        before={<Typography className={classes.selDocuments}>{`${Tr('documents_selected')}: ${selectedFileMap.size}`} </Typography>}
                    />
                </>
            }
        >

            {working && <Loading className={classes.loading}/>}
            {!!filesAndFolders && <>
                <EzdrpList documents={filesAndFolders} selectedFileMap={selectedFileMap} expandedFileMap={expandedFileMap} toggleSelectFile={toggleSelectFile}
                           toggleExpandFile={toggleExpandFile}/>
            </>}


        </Dialog>
    )
}

EzdrpExplorer.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
}

export default EzdrpExplorer;